import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-subtitle-2 mb-2 d-block" }
const _hoisted_2 = {
  "aria-live": "polite",
  style: {"font-weight":"bold"}
}
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "ml-1" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { type DayType, DAYS } from './date_time_range_generators';

const monthItemWidthPx = 60;

export default /*@__PURE__*/_defineComponent({
  __name: 'DaysPicker',
  props: /*@__PURE__*/_mergeModels({
    showErrorForEmpty: { type: Boolean }
  }, {
    "modelValue": {
  type: Array as () => DayType[],
  default: () => [...DAYS],
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const selectedDays = _useModel<DayType[]>(__props, "modelValue");

const empty = computed(() => selectedDays.value?.length === 0);


const columns = ref(1);
const cssVars = computed(() => ({
  '--column-count': columns.value
}));
const observer = new ResizeObserver(() => {
  updateColumnCount();
});

function updateColumnCount() {
  const container = document.getElementById('dtrs-days-picker') ;
  if (container) {
    columns.value = Math.max(Math.floor(container.clientWidth / monthItemWidthPx), 1);
  }
}
onMounted(() => {
  updateColumnCount();
  const container = document.getElementById('dtrs-days-picker') ;
  if (container) {
    observer.observe(container);
  }
});

onBeforeUnmount(() => {
  observer.disconnect();
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "dtrs-days-picker",
    class: _normalizeClass({'dtrs-error-highlight': __props.showErrorForEmpty && empty.value})
  }, [
    _createElementVNode("label", _hoisted_1, [
      _cache[1] || (_cache[1] = _createTextVNode("Days of Week ", -1)),
      _withDirectives(_createElementVNode("span", _hoisted_2, " (Select at least 1) ", 512), [
        [_vShow, __props.showErrorForEmpty && empty.value]
      ])
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle(cssVars.value),
      id: "dtrs-days-block"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DAYS), (day, idx) => {
        return (_openBlock(), _createElementBlock("label", {
          key: idx,
          class: "mr-3",
          style: {"text-wrap":"nowrap"}
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            value: day,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDays).value = $event))
          }, null, 8, _hoisted_3), [
            [_vModelCheckbox, selectedDays.value]
          ]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(day.slice(0,3)), 1)
        ]))
      }), 128))
    ], 4)
  ], 2))
}
}

})